import React from 'react';
import PropTypes from 'prop-types';

/**
 * LoginBanner component
 *
 * Sección izquierda del formulario de login, que muestra
 * información de bienvenida y detalles de los servicios ofrecidos.
 *
 * @component
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.leftSideContent - Contenido adicional opcional para mostrar debajo de la descripción principal
 * @returns {JSX.Element} Banner de bienvenida en la página de login
 */
const LoginBanner = ({ leftSideContent }) => {
	return (
		<>
			<div className="position-relative p-4 pt-md-5 pb-md-7">
				<div className="z-index-1 position-relative light text-white">
					<h3
						style={{
							marginBottom: '25px',
							textAlign: 'center'
						}}
					>
						Bienvenidos a Instituto CertifiED Learning and Development
					</h3>

					<h5
						style={{
							textAlign: 'left',
							marginBottom: '10px'
						}}
					>
						¿Por qué nosotros?
					</h5>

					<p
						className="text-white"
						style={{ textAlign: 'left' }}
					>
						¡Elige el Instituto CertifiED Learning and Development!
					</p>

					<div
						style={{
							marginBottom: '10px',
							textAlign: 'justify'
						}}
					>
						Certificamos tu nivel de inglés con una herramienta basada en el Marco Común Europeo, con validez ante la Secretaría de Educación. Además, certifícate como maestro de inglés en nuestra certificación en Metodologías de la Enseñanza del Inglés.
					</div>

					<div
						style={{
							marginBottom: '5px',
							textAlign: 'justify'
						}}
					>
						Nuestras certificaciones son vitalicias y en línea.
						Contamos con una plataforma interactiva que facilita tu aprendizaje y ofrecemos un programa de desarrollo de habilidades blandas, ¡Incluyendo un viaje internacional a una universidad Ivy League como premio! ¡Mejora tus habilidades y alcanza el éxito con nosotros!
					</div>

					<h5
						style={{
							textAlign: 'left',
							marginTop: '35px'
						}}
					>
						Nuestros servicios
					</h5>

					<div
						style={{
							marginBottom: '15px',
							textAlign: 'justify'
						}}
					>
						EPSt - English Proficiency Standard - Certificación del idioma inglés basado en el Marco Común de Referencia Europea con validez ante la Secretaría de Educación.
					</div>

					<div
						style={{
							marginBottom: '5px',
							textAlign: 'justify'
						}}
					>
						EMeT - English Methodologies Test - Certificación en la Enseñanza del Idioma Inglés con validez ante la Secretaría de Educación.
					</div>
				</div>
			</div>

			<div className="mt-3 mb-4 mt-md-4 mb-md-5 light">
				{leftSideContent}
			</div>
		</>
	);
};

LoginBanner.propTypes = {
	leftSideContent: PropTypes.node
};

export default LoginBanner;